import { render, staticRenderFns } from "./AccessibilityInitiative.vue?vue&type=template&id=811a3972&scoped=true&"
import script from "./AccessibilityInitiative.vue?vue&type=script&lang=ts&"
export * from "./AccessibilityInitiative.vue?vue&type=script&lang=ts&"
import style0 from "./AccessibilityInitiative.vue?vue&type=style&index=0&id=811a3972&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "811a3972",
  null
  
)

export default component.exports